module.exports = __webpack_public_path__ + "static/img/systemName.cdb01d5c.png";